import { adfModelTypeMap } from './../../registries/consts/adf-model-type-map-const';
import { Metamodel } from '../base/model';
import { format } from 'app/shared/utils/string.util';
import { DynamicsLinkedService } from './dynamics.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsCRM.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.DynamicsCRM_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.DynamicsCRM_DisplayText)
    ]
})
export class DynamicsCrmLinkedService extends DynamicsLinkedService {
}
